import { Input, Select, DateInput } from '@/components'
import Card from '@/components/Form/Card'
import { estadoCivil, estados } from '@/components/Form/Form.data'

import { ClientFieldsProps } from './ClientDataFields.type'

const ClientDataFields = ({ formData, onChange }: ClientFieldsProps) => (
  <Card title="Dados do Cliente">
    <div className="flex flex-col gap-4">
      <Input
        label="Titular da Fatura (Nome Completo)"
        placeholder="Digite o nome completo do titular da conta..."
        value={formData?.Cliente_REPC2}
        onChange={onChange}
        required
        name="Cliente_REPC2"
      />
      <Input
        label="CPF"
        maxLength={14}
        placeholder="Digite o CPF (Somente números)..."
        value={formData?.Cliente_CPFREPC2}
        onChange={onChange}
        required
        name="Cliente_CPFREPC2"
      />
      <Input
        label="E-mail"
        type="email"
        required
        placeholder="Digite o e-mail..."
        value={formData?.Cliente_EMAILREPC2}
        onChange={onChange}
        name="Cliente_EMAILREPC2"
      />
      <Input
        label="Nacionalidade"
        placeholder="Digite a Nacionalidade..."
        value={formData?.nacionalidade}
        onChange={onChange}
        required
        name="nacionalidade"
      />
      <Input
        label="Profissão"
        placeholder="Digite a Profissão..."
        value={formData?.Cliente_RZC2}
        onChange={onChange}
        required
        name="profissao"
      />
      <Select
        label="Estado Civil"
        selectedValue={formData?.estadoCivil || ''}
        options={estadoCivil}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange={onChange}
        center={false}
        name="estadoCivil"
      />
      <Input
        label="Telefone"
        placeholder="Digite o telefone com ddd..."
        value={formData?.Cliente_TELREPC2}
        onChange={onChange}
        required
        name="Cliente_TELREPC2"
      />
      <DateInput
        label="Data de nascimento do titular"
        placeholder="DD/MM/AAAA"
        value={formData?.Cliente_NASCIMENTO} // Campo do formulário
        onChange={onChange} // Atualiza o estado
        required
        name="Cliente_NASCIMENTO"
      />
      <Input
        label="Endereço"
        placeholder="Digite a rua, número, bairro e complemento"
        value={formData?.street}
        onChange={onChange}
        required
        name="street"
      />
      <Input
        label="Cidade"
        placeholder="Digite cidade"
        value={formData?.city}
        onChange={onChange}
        required
        name="city"
      />
      <Select
        name="state"
        label="Estado"
        selectedValue={formData?.state || ''}
        options={estados}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange={onChange}
        center={false}
      />
      <Input
        label="CEP"
        placeholder="Digite o CEP (Somente números)"
        value={formData?.postalCode}
        onChange={onChange}
        required
        name="postalCode"
      />
    </div>
  </Card>
)

export default ClientDataFields
